import { useQuery } from '@tanstack/react-query'
import Markdown from 'react-markdown'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  width: 100%;
  text-align: left;
  word-wrap: wrap;
  h1 {
    text-align: center;
  }
`

export const MarkdownPage: React.FC = () => {
  const location = useLocation()
  const { data: value } = useQuery({
    queryKey: [location.pathname],
    queryFn: async () => {
      let path = ''
      if (location.pathname.includes('terms')) {
        path = '/terms.md'
      } else if (location.pathname.includes('privacy')) {
        path = '/privacy.md'
      }
      const result = await getDoc(path)
      return result
    },
  })

  return (
    <Container>
      <Markdown>{value}</Markdown>
    </Container>
  )
}

const getDoc = async (path: string) => {
  const termDoc = await fetch(path)

  return await termDoc.text()
}
